module.exports = __webpack_public_path__ + "img/four1Blue.52e00233.jpg";